"use strict";
/**
|--------------------------------------------------
| Validate Forms Functions
|--------------------------------------------------
*/

export const validateFormBootstrap = (formClass) => {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    let forms = document.querySelectorAll(formClass)

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms).forEach(function (form) {
        form.setAttribute('novalidate', "");
        form.addEventListener('submit', function (event) {

            if (!form.checkValidity()) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                const recaptchaElement = form.querySelector('.g-recaptcha');
                if(recaptchaElement){
                    grecaptcha.execute();
                }
            }

            form.classList.add('was-validated');
        }, false);
    });
};
import Modal from "bootstrap/js/dist/modal";
export const validateFormModalBootstrap = (formClass) => {
	// Fetch all the forms we want to apply custom Bootstrap validation styles to
	let forms = document.querySelectorAll(formClass)

	// Loop over them and prevent submission
	Array.prototype.slice.call(forms).forEach(function (form) {
		const formModalTrigger = form.querySelector(formClass + "__trigger");
		if(!formModalTrigger) return;
		formModalTrigger.addEventListener('click', function() {
			if (form.checkValidity()) {
				// Get modal selector from "href" or "data-bs-target"
				const modalSelector = formModalTrigger.getAttribute('href') || formModalTrigger.getAttribute('data-bs-target');
				const modalElement = document.querySelector(modalSelector);
				if(!modalElement) return;
				const bsModal = Modal.getOrCreateInstance(modalSelector);
				bsModal.show();
			}

			form.classList.add('was-validated');
		})
	});
};